import Pie from 'd3vue/components/Pie.vue'
import { keepDimensions, buildCropFunction, valueAsNumber } from '../dataFilter'
import { toScale } from '../colors'
import Donut from '../config/Donut.vue'
import api from '../api'

export default {
  id: 'donut',
  label: 'Graphique en donut',
  component: Pie,
  dimensions: 1,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const props = {
      labelMode: 'legend-right',
      inner: 75
    }
    if (vue.colorScheme) {
      props.colorScale = toScale(vue.colorScheme)
    }
    vue.buildProps(props)
    return buildCropFunction(d => d.value, vue)(keepDimensions(1, data).map(d => {
      const value = valueAsNumber(d[api.measure.name(vue.measure[0])])
      return {
        data: d,
        value: value,
        label: `${d.Group0Caption} (${vue.props.yFormatter(value)})`
      }
    }).filter(d => !vue.noEmpty || d.value))
  },
  config: Donut
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/Donut.js